import { useState } from "react"
import { RegistrationForm } from "./components/RegistrationForm";
import { ConfirmationPage } from "./components/ConfirmationPage";
import { PopUpMessage } from "../../shared/components/PopUpMessage";
import { PickerValue } from "@mui/x-date-pickers/internals";
import axios from "axios";
import { RiCalendarEventLine, RiMapPinLine } from "react-icons/ri";

const SERVER = process.env.REACT_APP_SERVER;

export const PdoRegister = () => {
    const [page, setPage] = useState<"registration" | "confirmation">("registration");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState<PickerValue | null>(null);
    const [postSecondaryInstitution, setPostSecondaryInstitution] = useState("");
    const [popUpMessage, setPopUpMessage] = useState("");
    const [popUpOpen, setPopUpOpen] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [otherInstitution, setOtherInstitution] = useState("");
    const [joiningAs, setJoiningAs] = useState("");
    const [otherJoiningAs, setOtherJoiningAs] = useState("");
    const [questions, setQuestions] = useState("");


    const handleFieldChange = (field: string, value: string | boolean | PickerValue) => {
        switch (field) {
            case "firstName":
                setFirstName(value as string);
                break;
            case "lastName":
                setLastName(value as string);
                break;
            case "email":
                setEmail(value as string);
                break;
            case "phoneNumber":
                setPhoneNumber(value as string);
                break;
            case "dateOfBirth":
                setDateOfBirth(value as PickerValue);
                break;
            case "postSecondaryInstitution":
                setPostSecondaryInstitution(value as string);
                break;
            case "otherInstitution":
                setOtherInstitution(value as string);
                break;
            case "joiningAs":
                setJoiningAs(value as string);
                break;
            case "otherJoiningAs":
                setOtherJoiningAs(value as string);
                break;
            case "questions":
                setQuestions(value as string);
                break;
            default:
                break;
        }
    };


    const handleFailure = () => {
        setPopUpMessage("Service unvailable, please try again in a minute.");
        setPopUpOpen(true);
    }

    const handleSubmit = () => {
        if (
            !firstName.trim() ||
            !lastName.trim() ||
            !email.trim() ||
            !phoneNumber.trim() ||
            !dateOfBirth ||
            !postSecondaryInstitution ||
            (postSecondaryInstitution === "Other" && !otherInstitution.trim()) ||
            !joiningAs ||
            (joiningAs === "Other" && !otherJoiningAs.trim())
        ) {
            setPopUpMessage("Please fill out all required fields.");
            setPopUpOpen(true);
            return;
        }


        const res = {
            firstName,
            lastName,
            email,
            phoneNumber,
            dateOfBirth: dateOfBirth.format("DD-MM-YYYY"),
            postSecondaryInstitution:
                postSecondaryInstitution === "Other" ? otherInstitution : postSecondaryInstitution,
            joiningAs:
                joiningAs === "Other" ? otherJoiningAs : joiningAs,
            questions
        };


        console.table(res);
        setSubmitted(true);

        axios.post(`${SERVER}/pdo/register`, res, { timeout: 15000 }).then((res) => {
            if (res.status === 200) {
                setPage("confirmation");
                return;
            }
            handleFailure();
            setSubmitted(false);
        }).catch(() => {
            handleFailure();
            setSubmitted(false);
        });

    }


    return (
        <div>
            <PopUpMessage
                open={popUpOpen}
                handleClose={() => setPopUpOpen(false)}
                message={popUpMessage}
            />
            <div className="flex flex-col lg:flex-row min-h-screen pt-navbar py-40 mx-[10%]">
                <div className={`lg:order-2 flex-auto w-full`} >
                    <div className={`w-[100%] ${page === 'confirmation' ? "p-[12%]" : "px-[12%]"}`}>
                        <div className="flex justify-between items-center">
                            <h2>
                                {page === "confirmation"
                                    ? "Thank you for registering!"
                                    : "Register for PDO"}
                            </h2>
                        </div>
                        {page === "registration" &&
                            <div className="xl:max-w-[65%] py-6 flex flex-col gap-3">
                                <p>
                                    This event will give you a general idea of what to prepare and expect for new and incoming Indonesian international students when coming to Vancouver!
                                </p>
                                <div className="flex flex-col gap-2">
                                    <div className="flex items-start gap-2">
                                        <RiCalendarEventLine className="text-lg sm:text-xl text-[#D07D14] flex-shrink-0 mt-1" />
                                        <p className="text-sm sm:text-base">
                                            <strong>Date & Time:</strong> 17 July 2026, 8 PM PDT ~ 18 July 2026, 10 AM WIB
                                        </p>
                                    </div>
                                    <div className="flex items-start gap-2">
                                        <RiMapPinLine className="text-lg sm:text-xl text-[#D07D14] flex-shrink-0 mt-1" />
                                        <p className="text-sm sm:text-base">
                                            <strong>Location:</strong> Zoom (link will be emailed after registration)
                                        </p>
                                    </div>
                                </div>
                            </div>}
                        {page === "registration" && (
                            <>
                                <RegistrationForm
                                    state={{
                                        firstName,
                                        lastName,
                                        email,
                                        phoneNumber,
                                        dateOfBirth,
                                        postSecondaryInstitution,
                                        otherInstitution,
                                        joiningAs,
                                        otherJoiningAs,
                                        questions
                                    }}
                                    handleFieldChange={handleFieldChange}
                                />

                                <button
                                    className="block bg-[#D07D14] w-full rounded-md text-white py-1.5 text-lg mt-7 disabled:bg-gray-400"
                                    onClick={handleSubmit}
                                    disabled={submitted}
                                >
                                    Submit
                                </button>
                            </>
                        )}
                        {page === "confirmation" && <ConfirmationPage />}
                    </div>
                </div>
            </div>
        </div >
    )
}